
<template>
<!-- <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/404.png" alt="vuexy-logo" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">Opción en mantenimiento</h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse" style="color:black; font-weight:bold;">Pronto estará disponible.</p>
            <vs-button size="large" to="/">Volver al inicio</vs-button>
        </div>
    </div> -->
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <div class="p-4 flex flex-col w-full">
                <p class="messagePerfect" style="font-weight: 900;">Listado de útiles</p>
            </div>
        <vs-row>
                <vs-col type="flex"  vs-w="4" vs-sm="12" style="padding: 0.5rem; min-height: 15.85rem;" v-bind:key="item" v-for="(curso,item) in listadoCursos">
                    <vs-card class="cardx" >
                        <div class="text-center">
                            <p class="headerCardList" style="font-weight: 900;font-size: 1rem; height: 15px;">{{ curso.nombre_plantilla }}</p>
                        </div>
                        <div class="item-img text-center" style=" padding-top: 0.5rem;">
                            <img class="" v-bind:src="curso.img_ecommerce ? curso.img_ecommerce : require('@/assets/images/school_supplies_final.png')" alt="img-placeholder">
                        </div>
                        <div slot="footer">
                            <vs-row vs-justify="flex-end">
                            <vs-button color="primary" icon="get_app" @click="descargarPDF(curso)"></vs-button>
                            </vs-row>
                        </div>
                    </vs-card>
                </vs-col>
            </vs-row> 
            <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
                   <div class="flex flex-wrap justify-between my-5">
                      {{ (mensaje) == null ? null : mensaje }}
                   </div>      
                    <div class="flex flex-wrap justify-center mb-3">
                        <vs-button  color="primary" @click="popupMensaje = !popupMensaje">Aceptar</vs-button>
                    </div>
            </vs-popup>                      
      </vs-col>
    </vs-row>

</template>

<script>
export default {
    data() {
        return {
            popupMensaje:false,
            mensaje:null,
            listadoCursos:[]
        }
    },
    methods: {
        descargarPDF(curso){
            window.open(process.env.VUE_APP_DOMAIN_WS_WINDOW_OPEN+`mapgrafi/estudiante/generar-pdf/${curso.id_tabla}/${process.env.VUE_APP_COD_EMPRESA_ERP}`)
        }
    },
    created(){
        this.$vs.loading();
        this.$http.post(this.$store.state.domain+`mapgrafi/estudiante/lista-curso`,{
            "cod_empresa":process.env.VUE_APP_COD_EMPRESA_ERP,
            "evento":"DATA_TABLE_PRODUCTO_ECOMMERCE",
            "curso":null,
            "id_tabla":null,
	        "id_mencion":null
        })
        .then((response) => {
            this.$vs.loading.close(); 
            this.listadoCursos = response.data.data;
        })
        .catch((error)=>{
                this.$vs.loading.close(); 
                this.$vs.notify({
                    time:8000,
                    title: 'Mapgrafi informa',
                    text:  error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
        })
    }
}
</script>

<style>
.messagePerfect{
    font-size: 20px;
    font-weight: 400;
}
</style>